export default "__VITE_ASSET__DzJ7H$ph__"